import { render, staticRenderFns } from "./PortfolioDetailsTwo.vue?vue&type=template&id=51a0417d&"
import script from "./PortfolioDetailsTwo.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetailsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports